import { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { dapSubPages, navLinks } from '../data/content';
import { NavIcon, SubPageIcon } from './icons';
import './TabNav.css';

const NAV_ICON_BY_PATH: Record<string, string> = {
  '/portal/sqm-data-hub': 'data-hub',
  '/portal/contributions': 'contributions',
};

export function TabNav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const dropdownRef = useRef<HTMLDivElement>(null);

  const isSubPageActive = dapSubPages.some(
    (sub) => sub.path === location.pathname
  );

  // Close the dropdown on route change.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Close the dropdown when clicking outside of it.
  useEffect(() => {
    if (!open) return;
    function handleClick(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <nav className="tab-nav" aria-label="Primary">
      <div className="tab-nav__inner">
        <div className="tab-nav__dropdown-wrap" ref={dropdownRef}>
          <button
            type="button"
            className={`tab-nav__tab tab-nav__trigger${
              isSubPageActive ? ' tab-nav__tab--active' : ''
            }`}
            aria-haspopup="true"
            aria-expanded={open}
            onClick={() => setOpen((prev) => !prev)}
          >
            <span className="tab-nav__icon" aria-hidden>
              <NavIcon name="capabilities" />
            </span>
            What DAP-AI can do?
            <span className={`tab-nav__caret${open ? ' tab-nav__caret--up' : ''}`} aria-hidden>
              ▾
            </span>
          </button>

          {open && (
            <div className="tab-nav__menu" role="menu">
              {dapSubPages.map((sub) => (
                <NavLink
                  key={sub.slug}
                  to={sub.path}
                  end={sub.path === '/portal'}
                  role="menuitem"
                  className={({ isActive }) =>
                    `tab-nav__menu-item${
                      isActive ? ' tab-nav__menu-item--active' : ''
                    }`
                  }
                >
                  <span className="tab-nav__icon" aria-hidden>
                    <SubPageIcon slug={sub.slug} />
                  </span>
                  {sub.label}
                </NavLink>
              ))}
            </div>
          )}
        </div>

        {navLinks.map((link) => (
          <NavLink
            key={link.path}
            to={link.path}
            className={({ isActive }) =>
              `tab-nav__tab${isActive ? ' tab-nav__tab--active' : ''}`
            }
          >
            <span className="tab-nav__icon" aria-hidden>
              <NavIcon name={NAV_ICON_BY_PATH[link.path] ?? 'capabilities'} />
            </span>
            {link.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
